import { render, staticRenderFns } from "./AccDetail.vue?vue&type=template&id=1661ffba"
import script from "./AccDetail.vue?vue&type=script&lang=js"
export * from "./AccDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports